import { render, staticRenderFns } from "./SuggestToPC.vue?vue&type=template&id=311f8254&scoped=true&"
import script from "./SuggestToPC.vue?vue&type=script&lang=js&"
export * from "./SuggestToPC.vue?vue&type=script&lang=js&"
import style0 from "./SuggestToPC.vue?vue&type=style&index=0&id=311f8254&lang=scss&scoped=true&"
import style1 from "./SuggestToPC.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311f8254",
  null
  
)

component.options.__file = "SuggestToPC.vue"
export default component.exports